import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { memberMove, memberQualityChange, memberRepairMoney } from '../../../../api/apis';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      tagList: [{
        key: 0,
        value: '补仓'
      }, {
        key: 1,
        value: '扣仓'
      }],
      accountList: [{
        key: 'quantity',
        value: '云仓'
      }, {
        key: 'quantity2',
        value: '合约仓'
      }, {
        key: 'quantity3',
        value: '欠货仓'
      }],
      form: {
        number: '',
        type: 'quantity',
        tag: 0,
        happen_money: '',
        remark: ''
      },
      rules: {
        happen_money: [{
          require: true,
          validator: this.$tempModel.rules.money.validator,
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    show: function show(number, finish) {
      this.dialogVisible = true;
      this.form.number = number;
      this.finish = finish;
    },
    clickSubmit: function clickSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          memberQualityChange({
            number: _this.form.number,
            tp: _this.form.type,
            direction: _this.form.tag,
            quantity: _this.form.happen_money,
            remark: _this.form.remark
          }).then(function _callee(res) {
            return regeneratorRuntime.async(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this.$message({
                      message: '操作成功',
                      type: 'success'
                    });

                    _this.dialogVisible = false;

                    if (_this.finish) {
                      _this.finish();
                    }

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            });
          });
        }
      });
    }
  }
};